import PropTypes from 'prop-types';

const ContentSection = ({ content }) => {
  if (!content) return null;

  return (
    <div className="w-full py-8">
      <div className="container mx-auto px-4">
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

ContentSection.propTypes = {
  content: PropTypes.string,
};

export default ContentSection;